import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './style.m.less';

const RIBBON_COLORS = {
    GREEN: styles.green,
    RED: styles.red,
    BLUE: styles.blue,
    GREY: styles.grey,
    ORANGE: styles.orange,
};

const SIDES = {
    LEFT: {
        container: styles.leftContainer,
        label: styles.leftLabel,
    },
    RIGHT: {
        container: styles.rightContainer,
        label: styles.rightLabel,
    },
};

Ribbon.propTypes = {
    color: PropTypes.oneOf(Object.keys(RIBBON_COLORS)),
    text: PropTypes.string.isRequired,
    side: PropTypes.oneOf(Object.keys(SIDES)),
};

export default function Ribbon({ color = 'GREEN', text, side = 'LEFT', switchOnMobile = true }) {
    const { container, label } = SIDES[side];

    return (
        <div className={classNames(container, { [styles.switchOnMobile]: switchOnMobile }, RIBBON_COLORS[color])}>
            <span className={classNames(label, { [styles.switchOnMobile]: switchOnMobile })}>{text}</span>
        </div>
    );
}
